import React from "react";
import LanguageSwitch from "./LanguageSwitch";

const Toolbar = () => {
  return (
    <div className="toolbar">
      <LanguageSwitch />
    </div>
  );
};

export default Toolbar;
